import { useEffect, useState } from 'react'
import moment from 'moment'

import { Cell } from '../../../../components/ReusableComponents/Table'
import dashboardApi from '../../../../services/api/dashboard'
import styles from './InvoicePromiseToPayCell.module.scss'

const toInputValue = value => {
  if (!value) {
    return ''
  }

  const parsed = moment(value)
  return parsed.isValid() ? parsed.format('YYYY-MM-DD') : ''
}

const InvoicePromiseToPayCell = ({
  subsidiaryId,
  subsidiaryInvoiceId,
  promiseToPayDate
}) => {
  const [value, setValue] = useState(toInputValue(promiseToPayDate))
  const [isSaving, setIsSaving] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    setValue(toInputValue(promiseToPayDate))
  }, [promiseToPayDate])

  const handleChange = async event => {
    const nextValue = event.target.value
    const previousValue = value
    setValue(nextValue)
    setError(null)
    setIsSaving(true)

    try {
      await dashboardApi.upsertBillingInvoicePromiseToPay({
        subsidiaryId,
        subsidiaryInvoiceId,
        promiseToPayDate: nextValue || null
      })
    } catch (err) {
      setValue(previousValue)
      setError(err.message || 'Failed to save PTP date')
    } finally {
      setIsSaving(false)
    }
  }

  return (
    <Cell className={styles.cell}>
      <input
        className={styles.dateInput}
        type="date"
        value={value}
        onChange={handleChange}
        disabled={isSaving || !subsidiaryId || !subsidiaryInvoiceId}
        title={error || 'Promise to pay date'}
      />
      {error && <span className={styles.error}>{error}</span>}
    </Cell>
  )
}

export default InvoicePromiseToPayCell
